<template>
  <div class="children-day-draw-component">
    <ym-popup class="children-day-draw-popup"
              v-model="visible"
    >
      <div class="children-day-draw-container">
        <div class="children-day-draw-container-title">
          {{ prize.title }}
        </div>
        <ym-img class="children-day-draw-container-image"
                :src="prize.cover"
        />
        <div class="children-day-draw-container-content">
          {{ prize.desc }}
        </div>
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';

  export default {
    name: 'DrawPrizePopup',
    components: {
      'ym-popup': Popup,
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      prize: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        visible: false,
      };
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .children-day-draw {
    &-popup {
      background: none;
    }
    &-container {
      width: 600px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: @color-white;
      border-radius: 20px;
      &-title {
        width: 100%;
        height: 106px;
        color: @color-white;
        font-size: 42px;
        text-align: center;
        line-height: 106px;
        background: #f75748;
        border-radius: 20px 20px 0 0;
      }
      &-image {
        width: 294px;
        height: 206px;
        margin: 56px 0 82px;
      }
      &-content {
        width: 402px;
        font-size: 34px;
        color: #f75748;
        line-height: 45px;
        text-align: center;
        margin-bottom: 102px;
      }
    }
  }
</style>
